import { openFacebookShare, openTwitterShare, analyticsPushFunc } from "../../../../widgetsUtils"
import { MailShareButton } from "../../../../siteWidgets/socialShareButtons/mail/mailShareButton"
import { WhatsAppShareButton } from "../../../../siteWidgets/socialShareButtons/whatsApp/whatsAppShareButton"
import { FrontCopyButton } from "../../../../commonComponents/inline/frontCopyButton/frontCopyButton"

interface CalcalistArticleRailShareProps {
    articleTitle: string
    articleId: string
}

interface CalcalistArticleRailShareState {
    isOpen: boolean
}

export class CalcalistArticleRailShare extends React.Component<CalcalistArticleRailShareProps, CalcalistArticleRailShareState> {
    public static siteScriptName = "CalcalistArticleRailShare"

    private rootRef: HTMLElement

    constructor(props: CalcalistArticleRailShareProps) {
        super(props)
        this.state = { isOpen: false }
    }

    componentDidMount() {
        document.addEventListener("click", this.onDocumentClick, false)
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.onDocumentClick, false)
    }

    private onDocumentClick = (e: MouseEvent) => {
        if (!this.state.isOpen || !this.rootRef) {
            return
        }
        if (!this.rootRef.contains(e.target as Node)) {
            this.setState({ isOpen: false })
        }
    }

    private toggleShare = () => {
        this.setState({ isOpen: !this.state.isOpen })
    }

    private handleShareBtnClicked = (button: string) => {
        if (typeof window === "undefined") {
            return
        }
        const current_url = window.location.href
        const { articleTitle } = this.props
        switch (button) {
            case "fb":
                openFacebookShare(current_url, "", () => analyticsPushFunc("Facebook", "Article Side", articleTitle), "Article Side")
                break
            case "tw":
                openTwitterShare(current_url, () => analyticsPushFunc("Twitter", "Article Side", articleTitle), "Article Side")
                break
            case "wa":
                WhatsAppShareButton.openWhatsAppShare(current_url, () => analyticsPushFunc("Whatsapp", "Article Side", articleTitle), "Article Side")
                break
            case "mailto":
                MailShareButton.openMailShare(articleTitle, current_url, "heCalcalist", () => analyticsPushFunc("Mail", "Article Side", articleTitle), "Article Side")
                break
        }
    }

    private getCopyUrl = () => {
        const { articleId } = this.props
        const copy_url_link = typeof window === "undefined" ? "https://calcalist.co.il" : window.location.origin + window.location.pathname
        return `${copy_url_link}?utm_source=calcalist.co.il&utm_medium=Share&utm_campaign=copy_url#${articleId}`
    }

    render() {
        const { isOpen } = this.state
        return (
            <div
                className={`calcalistArticleRailShare ${isOpen ? "isOpen" : ""}`}
                ref={ref => this.rootRef = ref}
            >
                <button
                    type="button"
                    className="calcalistArticleRailShareToggle"
                    onClick={this.toggleShare}
                    aria-expanded={isOpen}
                    aria-controls="calcalistArticleRailShareList"
                    title="שיתוף"
                >
                    <span className="calcalistArticleRailShareToggleIcon"></span>
                </button>
                <button type="button" className="calcalistArticleRailShareBtn whatsapp" title="Whatsapp" onClick={() => this.handleShareBtnClicked("wa")}>
                    <span className="calcalistArticleRailShareBtnIcon"></span>
                </button>
                <div id="calcalistArticleRailShareList" className="calcalistArticleRailShareList">
                    <button type="button" className="calcalistArticleRailShareBtn twitter" title="Twitter" onClick={() => this.handleShareBtnClicked("tw")}>
                        <span className="calcalistArticleRailShareBtnIcon"></span>
                    </button>
                    <button type="button" className="calcalistArticleRailShareBtn facebook" title="Facebook" onClick={() => this.handleShareBtnClicked("fb")}>
                        <span className="calcalistArticleRailShareBtnIcon"></span>
                    </button>
                    <button type="button" className="calcalistArticleRailShareBtn mail" title="Email" onClick={() => this.handleShareBtnClicked("mailto")}>
                        <span className="calcalistArticleRailShareBtnIcon"></span>
                    </button>
                    <FrontCopyButton
                        popupText="הקישור הועתק ללוח"
                        classes="calcalistArticleRailShareBtn copy"
                        title="העתק קישור"
                        alt="העתק קישור"
                        url={this.getCopyUrl()}
                    >
                        <span className="calcalistArticleRailShareBtnIcon"></span>
                    </FrontCopyButton>
                </div>
            </div>
        )
    }
}
